import { FC, InputHTMLAttributes } from 'react';
import { useMeasure } from 'react-use';

import {
  $HiddenDiv,
  $HiddenInput,
  $HiddenInputContainer,
} from './HiddenInput.styles';

export interface HiddenInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'disabled'
> {
  value?: string | number;
  defaultValue?: string | number;
  isDisabled?: boolean;
  dataTestId?: string;
}

const HiddenInput: FC<HiddenInputProps> = ({
  value,
  defaultValue,
  isDisabled = false,
  dataTestId,
  readOnly,
  onChange,
  name,
  placeholder,
  ...rest
}) => {
  const [ref, { width }] = useMeasure<HTMLDivElement>();

  return (
    <$HiddenInputContainer>
      <$HiddenDiv ref={ref}>{value ?? ''}</$HiddenDiv>
      <$HiddenInput
        name={name}
        value={value as any}
        defaultValue={defaultValue as any}
        placeholder={placeholder}
        onChange={onChange}
        readOnly={readOnly}
        disabled={isDisabled}
        data-testid={dataTestId}
        $width={width}
        {...rest}
      />
    </$HiddenInputContainer>
  );
};

export default HiddenInput;
